import React from "react";
import Loadable from "../../react-loadable";

const WeaCollet = Loadable({
  loader: () => import("./public"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaCollet;



// WEBPACK FOOTER //
// ./ecology9/wea-collect/index.js